import { renderSlot as _renderSlot, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex justify-end border-t border-en-blue-200 p-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["PopoverRoot"], {
            open: $setup.open,
            "onUpdate:open": _cache[2] || (_cache[2] = ($event) => (($setup.open) = $event))
        }, {
            default: _withCtx(() => [
                _createVNode($setup["PopoverTrigger"], { "as-child": "" }, {
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "trigger", {}, () => [
                            _createElementVNode("div", {
                                class: _normalizeClass($props.isDisabled && 'pointer-events-none')
                            }, [
                                _createVNode($setup["EnTextField"], {
                                    id: $props.id,
                                    "static-id": $props.staticId ?? $props.id,
                                    name: $props.name,
                                    label: $setup.labelComputed,
                                    "model-value": $setup.dateFormatted,
                                    placeholder: $props.placeholder || '',
                                    disabled: $props.isDisabled,
                                    rules: $props.rules,
                                    hint: $props.hint,
                                    "persistent-hint": $props.persistentHint,
                                    readonly: ""
                                }, {
                                    append: _withCtx(() => [
                                        ($props.clearable && $setup.modelValue)
                                            ? (_openBlock(), _createBlock($setup["EnButton"], {
                                                key: 0,
                                                variant: "ghost",
                                                size: "icon-sm",
                                                class: "shrink-0 mr-1 text-muted-foreground hover:text-destructive transition-colors",
                                                tabindex: "-1",
                                                onClick: _withModifiers($setup.onClear, ["stop"])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode($setup["ClearIcon"], { size: 12 })
                                                ]),
                                                _: 1 /* STABLE */
                                            }))
                                            : _createCommentVNode("v-if", true),
                                        _createVNode($setup["CalendarIcon"], {
                                            size: 16,
                                            class: "text-muted-foreground"
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["id", "static-id", "name", "label", "model-value", "placeholder", "disabled", "rules", "hint", "persistent-hint"])
                            ], 2 /* CLASS */)
                        ])
                    ]),
                    _: 3 /* FORWARDED */
                }),
                _createVNode($setup["PopoverContent"], { class: "p-0" }, {
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "header"),
                        _createVNode($setup["Calendar"], {
                            locale: $setup.locale,
                            "prevent-deselect": true,
                            "model-value": $setup.shownCalendarValue,
                            "is-date-unavailable": $setup.isDateUnavailable,
                            "show-month-year-dropdowns": $props.showMonthYearDropdowns,
                            variant: $props.calendarVariant,
                            "onUpdate:modelValue": $setup.onCalendarSelect,
                            placeholder: $setup.calendarPage,
                            "onUpdate:placeholder": _cache[0] || (_cache[0] = ($event) => (($setup.calendarPage) = $event))
                        }, null, 8 /* PROPS */, ["locale", "model-value", "is-date-unavailable", "show-month-year-dropdowns", "variant", "placeholder"]),
                        ($props.confirmText)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode($setup["EnButton"], {
                                    disabled: !$setup.pickedValue,
                                    size: "sm",
                                    variant: "default",
                                    onClick: _cache[1] || (_cache[1] = ($event) => ($setup.takeOver($setup.pickedValue)))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($props.confirmText), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 3 /* FORWARDED */
                })
            ]),
            _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["open"])
    ]));
}
